(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-tag-filter-search"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-blog-filter]').forEach(function(root) {

  var cards = Array.prototype.slice.call(
    root.querySelectorAll('[data-blog-card]')
  );

  var tabs = Array.prototype.slice.call(
    root.querySelectorAll('[data-blog-tabs] button')
  );

  var search = root.querySelector('[data-blog-search]');
  var empty = root.querySelector('[data-blog-no-results]');

  var template =
    root.dataset.noResultsText ||
    'No blogs related to your search were found in {{ tab }}.';

  var urlParams = new URLSearchParams(window.location.search);

  var activeTag = urlParams.get('category') || 'all';

  var activeLabel = 'Show all';


  function setActiveTab(tag) {

    tabs.forEach(function(tab) {

      tab.classList.remove('is-active');
      tab.setAttribute('aria-selected', 'false');

      if (tab.dataset.tag === tag) {

        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        activeLabel = tab.textContent.trim();

      }

    });

  }


  function applyFilter() {

    var query = search
      ? search.value.trim().toLowerCase()
      : '';

    var visibleCards = [];

    cards.forEach(function(card) {

      var tags = (card.dataset.tags || '')
        .split('|')
        .filter(Boolean);

      var title = card.dataset.title || '';
      var content = card.dataset.content || '';

      var tagOk =
        activeTag === 'all' ||
        tags.includes(activeTag);

      var searchOk =
        !query ||
        title.includes(query) ||
        content.includes(query);

      var show = tagOk && searchOk;

      card.hidden = !show;

      card.classList.remove('blog-card--featured');

      if (show) {
        visibleCards.push(card);
      }

    });


    if (visibleCards.length > 0) {

      visibleCards[0].classList.add('blog-card--featured');

    }


    var visible = visibleCards.length;


    if (empty) {

      if (visible === 0) {

        empty.textContent = template.replace(
          '{{ tab }}',
          activeLabel
        );

        empty.hidden = false;

      } else {

        empty.hidden = true;

      }

    }

  }



  tabs.forEach(function(tab) {

    tab.addEventListener('click', function() {

      activeTag = tab.dataset.tag;

      activeLabel = tab.textContent.trim();


      setActiveTab(activeTag);


      if (activeTag === 'all') {

        history.pushState(
          {},
          '',
          window.location.pathname
        );

      } else {

        var url = new URL(window.location.href);

        url.searchParams.set(
          'category',
          activeTag
        );

        history.pushState(
          {},
          '',
          url
        );

      }


      applyFilter();

    });

  });



  root.querySelectorAll('[data-card-tag]').forEach(function(tag) {

    tag.addEventListener('click', function() {


      activeTag = tag.dataset.blogTag;


      var matchingTab = root.querySelector(
        '[data-blog-tabs] [data-tag="' + activeTag + '"]'
      );


      if (matchingTab) {

        matchingTab.click();

      }


    });

  });



  if (search) {

    search.addEventListener(
      'input',
      applyFilter
    );

  }



  if (
    activeTag !== 'all' &&
    root.querySelector('[data-blog-tabs] [data-tag="' + activeTag + '"]')
  ) {

    setActiveTab(activeTag);

  } else {

    activeTag = 'all';

    setActiveTab('all');

  }



  applyFilter();


});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
